module.exports = __webpack_public_path__ + "44a382a929b00e0a748be7e52dd93957.png";